module.exports = __webpack_public_path__ + "components/incentive/static/incentive-desktop-22d2124bc29152e6e7fc08ed15dc6f7c.webp";